import { render, staticRenderFns } from "./DrugDRLZ.vue?vue&type=template&id=1fe0f196&"
import script from "./DrugDRLZ.vue?vue&type=script&lang=js&"
export * from "./DrugDRLZ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports